/** Compiled EC omissions mean stored zero only when both instance anchors exist. */
export const EC_LEAN_ZERO = new Set(['creature_number', 'creature_initiative', 'v_current', 'v_max', 'v_temp', 'v_max_temp',
    'aps', 'aps_total', 'weapon_attack', 'head_attack', 'reaction', 'mana', 'luck', 'spirit',
    'hunger_meter_current', 'thirst_meter_current', 'movement_pct', 'movement_rev',
    'count_caster_summons', 'merchant_favor', 'encounter_creature_private',
    'encounter_creature_deleted', 'encounter_creature_dead']);
export function ecLean(row: Record<string, unknown>, column: string): unknown {
    const value = row.encounter_creatures;
    const bucket = value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : null;
    if (bucket && Object.prototype.hasOwnProperty.call(bucket, column)) return bucket[column];
    const anchored = (v: unknown): boolean => String(v ?? '').trim() !== '';
    return bucket && anchored(bucket.encounter_creature_id) && anchored(bucket.encounter_id) && EC_LEAN_ZERO.has(column) ? 0 : null;
}
